import React, { useEffect, useState } from 'react';
import { connect } from 'react-redux';
import axios from 'axios';
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import { API_BASE_URL } from '../../config';

import Pagination from '../Pagination/Paginations';
import EntriesSelector from '../Pagination/EntriesSelector';
import useSortData from '../Pagination/SortData';

import { Link, useLocation } from 'react-router-dom/cjs/react-router-dom.min.js';

const Course = () => {

  /* ================= STATES ================= */
  const [tableData, setTableData] = useState([]);
  const [searchTerm, setSearchTerm] = useState('');
  const [formData, setFormData] = useState({ course_name: '' });
  const [editData, setEditData] = useState({ id: '', course_name: '' });

 



const [currentPage, setCurrentPage] = useState(1);
const [entriesPerPage, setEntriesPerPage] = useState(10);

const { sortConfig, sortData, handleSort } = useSortData();


const { search } = useLocation();
  const searchparams = new URLSearchParams(search);
  const param = searchparams.get("course_id");

  /* ================= FETCH DATA ================= */
  useEffect(() => {
    fetchData();
  }, []);

 const fetchData = () => {
  axios.get(API_BASE_URL + '/course_management', {
    headers: { Authorization: `Bearer ${localStorage.getItem("authToken")}` }
  })
  .then(res => {
    const apiData = res.data.data.data;

    // console.log(apiData);


    // Ensure it's always array
    if (Array.isArray(apiData)) {
      setTableData(apiData);
    } else {
      setTableData([]);
    }
  })
  .catch(() => toast.error('Failed to load data'));
};

  /* ================= ADD EXIT ================= */
  const handleSubmit = (e) => {
    e.preventDefault();

    axios.post(API_BASE_URL + '/add_course', formData, {
      headers: { Authorization: `Bearer ${localStorage.getItem("authToken")}` }
    })
    .then(res => {
      toast.success(res.data.message);
      setFormData({ exit_type: '' });
      fetchData();
    })
    .catch(err => {
      toast.error(err.response?.data?.message || 'Error');
    });
  };

  /* ================= UPDATE EXIT ================= */
  const handleEditSubmit = (e) => {
    e.preventDefault();
     e.stopPropagation();

    axios.post(API_BASE_URL + '/updatecourse', editData, {
      headers: { Authorization: `Bearer ${localStorage.getItem("authToken")}` }
    })
    .then(res => {
      toast.success(res.data.message);
      fetchData();
      window.$('#editModal').modal('hide');
    });

     return false;
  };

  /* ================= SEARCH ================= */
  const filteredData = tableData.filter(item =>
    item.course_name?.toLowerCase().includes(searchTerm.toLowerCase())
  );

  /* ================= DATATABLE STYLES ================= */
  const customStyles = {
    headCells: {
      style: {
        fontWeight: '600',
        fontSize: '13px',
        backgroundColor: '#f8f9fa',
      },
    },
    cells: {
      style: {
        fontSize: '13px',
        paddingTop: '8px',
        paddingBottom: '8px',
      },
    },
    rows: {
      style: {
        minHeight: '42px',
      },
    },
  };

  /* ================= TABLE COLUMNS ================= */
  const columns = [
    
    {
      name: 'Course Name',
      selector: row => row.course_name,
      sortable: true,
    },
    {
      name: 'Create Date',
      selector: row => row.created_at,
    },
    {
      name: 'Action',
      width: '100px',
      cell: row => (
        <button
          className="btn btn-icon btn-sm"
          data-toggle="modal"
          data-target="#editModal"
          onClick={() => setEditData(row)}
        >
          <i className="fa fa-edit" />
        </button>
      ),
    },
  ];

  const filteredItems = tableData.filter(item =>
  item.course_name?.toLowerCase().includes(searchTerm.toLowerCase())
);

const totalPages = Math.ceil(filteredItems.length / entriesPerPage);

const indexOfLast = currentPage * entriesPerPage;
const indexOfFirst = indexOfLast - entriesPerPage;

const sortedItems = sortData(filteredItems);
// const filteredData = sortedItems.slice(indexOfFirst, indexOfLast);

  return (
    <>
      <ToastContainer position='bottom-right' />

      <div className="section-body">
        <div className="container-fluid">

          {/* ================= ADD EXIT MANAGEMENT ================= */}
          <div className="card mb-4">
            <div className="card-body">
              <h3 className="card-title d-flex align-items-center mb-3" style={{ color: "#1d3a8a", fontWeight: 600 }}>
                <i className="fa fa-book mr-2" style={{ fontSize: "20px" }} />
                Add Course
              </h3>

              <form onSubmit={handleSubmit}>
                <div className="row align-items-end">
                  <div className="col-md-4 required-tooltip">
                    <label>
                      Course Name 
                    </label>
                    <input
                      type="text"
                      className="form-control required-input"
                      required
                      value={formData.course_name}
                      onChange={e =>
                        setFormData({
                          course_name: e.target.value.replace(/[^A-Za-z ]/g, ''),
                        })
                      }
                    />
                  </div>
                  <div className="col-md-2">
                    <button className="btn btn-primary btn-sm">
                      Save
                    </button>
                  </div>
                </div>
              </form>
            </div>
          </div>

          {/* ================= EXIT LIST ================= */}
          <div className="card">
            <div className="card-header d-flex align-items-center">
              <h3 className="card-title d-flex align-items-center mb-0" style={{ color: "#1d3a8a", fontWeight: 600 }}>
                <i className="fa fa-book mr-2" style={{ fontSize: "20px" }} />
                COURSE LIST
              </h3>

               <div
    className="card-options"
    style={{
      display: "flex",
      alignItems: "center",
      gap: "12px",
    }}
  >
    <EntriesSelector
      entriesPerPage={entriesPerPage}
      setEntriesPerPage={setEntriesPerPage}
      setCurrentPage={setCurrentPage}
    />

    <div style={{ position: "relative", width: "200px" }}>
      <input
        type="text"
        className="form-control form-control-sm"
        placeholder="Search"
        value={searchTerm}
        onChange={(e) => {
          setSearchTerm(e.target.value);
          setCurrentPage(1);
        }}
        style={{
          height: "30px",
          fontSize: "13px",
          paddingRight: "28px",
        }}
      />

      {searchTerm.length > 0 && (
        <span
          onClick={() => setSearchTerm("")}
          style={{
            position: "absolute",
            right: "8px",
            top: "50%",
            transform: "translateY(-50%)",
            cursor: "pointer",
            fontSize: "16px",
          }}
        >
          ✖
        </span>
      )}
    </div>
  </div>
            </div>

            <div className="card-body p-0">
              <div className="card-body">
  <div className="table-responsive">
    <table className="table table-hover table-striped table-vcenter text-nowrap mb-0">
      <thead>
        <tr>
          <th>Action</th>

          <th
            onClick={() => handleSort("course_name")}
            style={{ cursor: "pointer" }}
          >
            Course Name
            {sortConfig.key === "course_name"
              ? sortConfig.direction === "asc"
                ? " ▲"
                : " ▼"
              : " ⇅"}
          </th>

          <th
            onClick={() => handleSort("created_at")}
            style={{ cursor: "pointer" }}
          >
            Create Date
            {sortConfig.key === "created_at"
              ? sortConfig.direction === "asc"
                ? " ▲"
                : " ▼"
              : " ⇅"}
          </th>
        </tr>
      </thead>

      <tbody>
        {filteredData.map((course, index) => (
          <tr key={index}>
            <td>
  <div style={{ display: "flex", alignItems: "center", gap: "8px" }}>
    
    <button
      className="btn btn-sm btn-outline-primary"
      data-toggle="modal"
      data-target="#editModal"
      onClick={() => setEditData(course)}
    >
      <i className="fe fe-edit" />
    </button>

    <Link
      to={`/TopicList?course_id=${course.id}`}
      className="btn btn-sm btn-outline-secondary"
    >
      <i className="fe fe-maximize" />
    </Link>

  </div>
</td>

            <td>{course.course_name}</td>
            <td>{course.created_at}</td>
          </tr>
        ))}
      </tbody>
    </table>
  </div>

  {/* Pagination */}
  <Pagination
    currentPage={currentPage}
    totalPages={totalPages}
    onPageChange={setCurrentPage}
  />
</div>
            </div>
          </div>

        </div>
      </div>

      {/* ================= EDIT MODAL ================= */}
      <div className="modal fade" id="editModal" tabIndex="-1">
        <form onSubmit={handleEditSubmit}>
          <div className="modal-dialog">
            <div className="modal-content">
              <div className="modal-header">
                <h5 className="modal-title">Edit Course</h5>
                <button className="close" data-dismiss="modal">×</button>
              </div>

              <div className="modal-body required-tooltip">
                <label>Course Name</label>
                <input
                  type="text"
                  className="form-control required-input"
                  value={editData.course_name || ''}
                  onChange={e =>
                    setEditData({ ...editData, course_name: e.target.value })
                  }
                  
                />
              </div>

              <div className="modal-footer">
                <button
                  type="button"
                  className="btn btn-secondary"
                  data-dismiss="modal"
                >
                  Close
                </button>
                <button className="btn btn-primary">
                  Save
                </button>
              </div>
            </div>
          </div>
        </form>
      </div>
    </>
  );
};

export default connect()(Course);
